
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CPPageWrapper extends Vue {

  @Prop({ default: false })
  public loginAs!: boolean;
}
